exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-6eaba780]{cursor:pointer}", ""]);

// exports
